export default {
    path: 'mcn_performance',
    name: 'mcn_performance',
    component: () => import('@/pages/mcn_performance_data/Performance'),
    meta: { title: '绩效目标' },
    children: [
        {
            path: 'objectives',
            name: 'performance_objectives',
            component: () => import('@/pages/mcn_performance_data/PerformanceObjectives'),
            meta: { title: '绩效目标一览' },
        },
        {
            path: 'director',
            name: 'performance_bonus',
            component: () => import('@/pages/mcn_performance_data/directorIndex.vue'),
            meta: { title: '总监绩效' },
        },
        {
            path: 'vp',
            name: 'case_record',
            component: () => import('@/pages/mcn_performance_data/vpIndex.vue'),
            meta: { title: 'vp绩效' },
        },
        // {
        //     path: 'objectives',
        //     name: 'performance_goal_achievement',
        //     component: () => import('@/pages/mcn_performance_data/performance_goal_achievement.vue'),
        //     meta: { title: '绩效完成-项目组' },
        // },
    ]
}
